import supportMdl from "./support.mdl";

export default [...supportMdl];
